import type { ReactNode } from 'react';
import './chip.css';

export type TomChip = 'neutro' | 'etapa' | 'canal' | 'erro' | 'atencao' | 'stale';

export type ChipProps = {
  tom?: TomChip;
  /** Explicação ao pousar o mouse — obrigatória no tom `stale`. */
  title?: string;
  children?: ReactNode;
};

export function Chip({ tom = 'neutro', title, children }: ChipProps) {
  return (
    <span className={tom === 'neutro' ? 'chip' : `chip chip--${tom}`} title={title}>
      {children}
    </span>
  );
}
